import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import { useQuery } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import S3FileUpload from 'react-s3';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import swal from '@sweetalert/with-react';

export default class ViewofContractReview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            //   orgCode : props.match.params.orgcode,
            //   auditplanurl: "",

            reportOfcontractreview: {
                orgCode: props.match.params.orgcode,
                contractreviewurl: "",

            },
            editStatus: false,
            showMessage: false,

            data: {},
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedProcessUrl: "",
            submitStatus: false,
            uploadStatus : true,
            messageforvalidation :"none",
            isLoading: false
        }
        this.viewprocessUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }

    componentDidMount() {
        const api = APIURL + '/api/rfq/get/orgdetails/' + this.state.reportOfcontractreview.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})

            .then(res => {
                console.log("data contract review", res.data.response)
                if (res.data.errorCode === 0) {
                    this.setState({ data: res.data.response })
                    if (res.data.response.statusoOfApplication === 'Accepted' && res.data.response.contractreviewStatus) {
                        this.setState({ editStatus: true })
                        if (this.state.data.contractreviewurl) {
                            var uplodedFileName= this.state.data.contractreviewurl.split("/")
                            var uplodedFileNameToView = uplodedFileName[4]
                            this.setState({ uploadedProcessUrl: this.state.data.contractreviewurl ,uploadedFileNameToshow: uplodedFileNameToView})
                            this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block", downloadbuttonStatus: "none" })
                        }
                        else if (!this.state.data.contractreviewurl) {
                            this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", downloadbuttonStatus: "block" })
                        }
                    }
                    else if (res.data.response.statusoOfApplication === 'Accepted' && !res.data.response.contractreviewStatus) {
                        this.setState({ editStatus: true, message: "Contract Review Checklist Data Not Filled", showMessage: true })
                    }
                    else if (res.data.response.statusoOfApplication === 'Rejected') {
                        this.setState({ editStatus: false, message: "This Company's Application Status Is Rejected.", showMessage: true })
                    }
                    else {
                        this.setState({ editStatus: false, message: "Application Status of this Company is Not Submitted.", showMessage: true })
                    }

                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);

                console.log("found", found);
                if (found !== null) {
                     window.location.href = "/signin"
                    // alert("if")
                    this.setState({isLoading:true})
                }
            })
            


    }

    handleprocessreview = (event) => {
        event.preventDefault();
        let newArr = this.viewprocessUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if(file1 <= 3072 ){
        S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                console.log("data s3",data)
                var tempData =this.state.reportOfcontractreview;
                tempData.contractreviewurl = data.location
                var docType = this.checkFileExtension(data.location)
                var file= data.key.split("/")
                var fileName = file[1];
                this.setState({ contractreviewurl: tempData, 
                                showFile: docType ,
                                uploadStatus :false, 
                                messageforvalidation : "none",
                                fileToUpload : data.location,
                                filenameToview : fileName
                            });
            })
            .catch(err => console.error(err))
        }
        else{
            this.setState({filenameToview : "",messageforvalidation : "block"})
        }
    }; 
    downloadUploadPdf=()=>{
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.fileToUpload
        window.open(link)
    }
    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }
    removeDoc = () => {
        var tempData = this.state.reportOfcontractreview;
        tempData.contractreviewurl = ""
        this.setState({  reportOfcontractreview: tempData ,uploadStatus :true});
    }
    removeUplodedDoc = (id) => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest ={
                                         "orgCode":this.state.data.orgCode,
                                      
                                    }
                  
                    axios.patch(APIURL + "/api/rfq/patch/contractreviewurl",jsonRequest)
                    .then((res) => {
                        if (res.data.errorCode === 0) {
                           
                            this.setState({
                                uploadDocumentStatus: "block",
                                uploadedDocumentStatus: "none",
                                uploadProcessUrl: "",
                                uploadStatus: true,
                                uploadedProcessUrl: "",
                                editStatus: true
                            })
                        }
                        else {
                            ToastInstance('Error', 'Something Went Wrong')
                        }
                    })
                    .catch(err => {
                        ToastInstance('warning', 'Something Went Wrong..Please Try again')
                    })

                }
            })
    }
    
    handleRoute = () => {
        window.location.href = "/" + localStorage.getItem("role") + "/contractreview/" + this.state.reportOfcontractreview.orgCode;
    }
    generateReviewProcess = () => {
        return axios.get(APIURL+'/api/generatepdf/get/contractreviewpdf/' + this.state.reportOfcontractreview.orgCode, {
           
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        ) 
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.data.orgSerialNumber   + '- Contract Review ' + `.pdf`
                link.click()
            })
    }
    postData = () => {
        var jsonRequest = {
            orgCode: this.state.reportOfcontractreview.orgCode,
            contractreviewurl: this.state.reportOfcontractreview.contractreviewurl,
        }
        console.log("json",jsonRequest)
        axios.patch(APIURL + "/api/rfq/patch/contractreviewerurl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'Contract Review Updated')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)
    }
    render() {
        const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.reportOfcontractreview.contractreviewurl} style={{ width: '80px', height: '80px' }}  onClick={()=>this.downloadUploadPdf()}/>
                    <p>{this.state.filenameToview}</p>
                    <span>
                        <h6 onClick={() => this.removeDoc('contractreviewurl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                     <div className="row">
                         <div className="col-sm-12">
                             <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadUploadPdf()} />

                             <span>
                                 <h6 onClick={() => this.removeDoc('contractreviewurl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                             </span>
                         </div>
                         <div className="row">
                             <span>{this.state.filenameToview}</span>

                         </div>
                     </div>
                    :
                    <>
                        <input type='file' ref={this.processUrlInput} onChange={this.handleprocessreview} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            window.location.href="/signin"
            return(<h1>Loading</h1>)
        }
        return (
            <div>

                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {
                                    this.state.showMessage ?

                                        <div className="text-center"><p style={{ fontSize: "25Px", color: "red" }}>{this.state.message}</p></div>
                                        :
                                        null
                                }
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "50px" }}>
                                        <div className="row">
                                            <div className="col-sm-12">
                                               
                                                    <div className="row headingcolor">
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>General Information</h5>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div className="row">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Request Date</label>
                                                        <div className="col-sm-3">
                                                            <p>{moment(this.state.data.reqDate).format('DD-MMM-YYYY')}</p>
                                                        </div>

                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contract Date</label>
                                                        <div className="col-sm-3">
                                                            <p>{moment(this.state.data.contractDate).format('DD-MMM-YYYY')}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Company Name</label>
                                                        <div className="col-sm-9">
                                                            <p>{this.state.data.orgName}</p>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Address</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.address}</p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope</label>
                                                        <div className="col-sm-9">
                                                            <p>{this.state.data.scope}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Risk Level</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.riskLevel}</p>
                                                        </div>
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">No Of Shifts</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.noOfShifts}</p>
                                                        </div>

                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Nace Code</label>
                                                        <div className="col-sm-9">
                                                            <p>{this.state.data.nabcbcodeName}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Permenant Employees</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.permanentTotal}</p>
                                                        </div>
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Employees Per Shift / Part Time Employees</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.contractualTotal}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Temporary Employees</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.partTimeTotal}</p>
                                                        </div>

                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Total No of Employees</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.total}</p>
                                                        </div>


                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Effective Number of Employees to be Audited</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.effectiveNoEmpToBeAudited}</p>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Sites to be covered in Audit</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.sitesTobeCoveredInAudit}</p>
                                                        </div>

                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of the Consultant / Business associates (if any)</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.nameOfConsultantOrBussinessAsso}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-12 labelsize">Justification for Effective Number of Employees Consideration</label>
                                                        </div>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <p>{this.state.data.justificationEffNoEmpConsideration}</p>
                                                        </div>


                                                    </div>
                                                    <div className="row  mt-4">
                                                    <div className="hrstyle headingcolor">
                                                        <h5>Mandays required (Stage1 & Stage 2/Recertification)</h5>
                                                    </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        {/* <label htmlFor="staticEmail" className="col-sm-3 labelsize">Mandays required (Stage1 & Stage 3/Recertification)</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.mandays}</p>
                                                        </div> */}
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Mandays Planned</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.mandaysPlanned}</p>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Stage 1 Audit</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.stageOneAudit}</p>
                                                        </div>

                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Stage 2 Audit</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.stageTwoAudit}</p>
                                                        </div>


                                                    </div>
                                                    
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Certification Standard Type</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.certificatestandardtype}</p>
                                                        </div>
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Certification Activity Type</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.certificateactivitytype}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-12 labelsize">Remarks for Reducing/ Increasing the Mandays with respect to effective number of employees/ scope and Risk Level</label>
                                                        </div>
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <p>{this.state.data.remarkforInsDecMandyas}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-12 labelsize">Reason of the transfer to IQCPL from another Certification Body </label>
                                                        </div>
                                                        <div className="row">
                                                        <div className="col-sm-12">                           
                                                            <p>{this.state.data.resonOfTransfer}</p>
                                                        </div>


                                                    </div>
                                                   
                                                    <div className="row mt-4">
                                                        <div className="hrstyle headingcolor ">
                                                            <h5>Any threat to impartiality</h5>
                                                        </div>
                                                    </div>
                                                 
                                                    <div className="row mt-5">

                                                        <table className="table table-bordered ">
                                                            <thead className="table-primary">
                                                                <tr className="fontcontractviewtable">
                                                                    <th className="text-center">Sr No</th>
                                                                    <th scope="col" className="text-center" width="50%">Type of Threat</th>
                                                                    <th scope="col" className="text-center">Yes/No</th>
                                                                    <th scope="col" className="text-center">Comments/Remarks</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody >

                                                                <tr >
                                                                    <td className="text-center" >1</td>
                                                                    <td className="fontcontractviewtable">Ownership, Governance and Management Current boards of directors are responsible for this area.
                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatOne}</td>

                                                                    <td>{this.state.data.threatOneremark}</td>

                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">2</td>
                                                                    <td className="fontcontractviewtable">Personnel (on Roll) at auditing/Review-Relatives working in top level.
                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatTwo}</td>

                                                                    <td>{this.state.data.threatTworemark}</td>

                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">3</td>
                                                                    <td className="fontcontractviewtable">Previous Employment
                                                                        -Holding Shares with the organization to be Certified.
                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatThree}</td>

                                                                    <td>{this.state.data.threatThreeremark}</td>

                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">4</td>
                                                                    <td className="fontcontractviewtable">Impartiality in Handling Application from own group of companies
                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatFour}</td>

                                                                    <td>{this.state.data.threatFourremark}</td>

                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">5</td>
                                                                    <td className="fontcontractviewtable">The possibility of Impartial Committee member influencing the auditing process
                                                                        If the Impartial committee member has any link with Client organization.


                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatFive}</td>

                                                                    <td>{this.state.data.threatFiveremark}</td>

                                                                </tr>

                                                                <tr>
                                                                    <td className="text-center">6</td>
                                                                    <td className="fontcontractviewtable">May be the clients representative is having the financial interest in IQCPL
                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatSix}</td>

                                                                    <td>{this.state.data.threatSixremark}</td>

                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">7</td>
                                                                    <td className="fontcontractviewtable">May be the impartiality committee members have association with the clients.
                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatSeven}</td>

                                                                    <td>{this.state.data.threatSevenremark}</td>

                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">8</td>
                                                                    <td className="fontcontractviewtable">Marketing Team may offer quick/Easy certification and may propose to do the consultancy and audits.
                                                                        Employees of the clients may offer the above situation


                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatEight}</td>

                                                                    <td>{this.state.data.threatEightremark}</td>

                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">9</td>
                                                                    <td className="fontcontractviewtable">Repeatedly sending the same auditor to the clients place may have an impact by development of the relationship
                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatNine}</td>

                                                                    <td>{this.state.data.threatNineremark}</td>

                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">10</td>
                                                                    <td className="fontcontractviewtable">Family Members are directly involved in operating the management system consultancy business
                                                                    </td>
                                                                    <td className="text-center">{this.state.data.threatTen}</td>

                                                                    <td>{this.state.data.threatTenremark}</td>

                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Auditor training verification</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.auditTrainVerification}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Is the scope covered by accreditation? </label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.scopeCoveredByaccreditation}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Frquency of Task</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.fruquencyoftask}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Mandays</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.surveillancemandays}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-12 labelsize">Outsource activities performed</label>
                                                        </div>
                                                        <div className="row">
                                                        <div className="col-sm-12">
                                                            <p>{this.state.data.outSourceActivity}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-12 labelsize">Does your company have any Not Applicable requirements identified,
                                                            if yes please list them out and provide the reasons
                                                            justification for non-applicability </label>
                                                            </div>
                                                        <div className="row">
                                                        <div className="col-sm-12">
                                                            <p>{this.state.data.notApplicableRequirement}</p>
                                                        </div>
                                                    </div>
                                                   
                                                   
                                                    <div className="row mt-4">
                                                        <div className="hrstyle headingcolor text-dark ">
                                                            <h5>Audit Team</h5>
                                                        </div>
                                                    </div>
                                                   
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Qualified Lead Auditor to appoint</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.teamleaderName}</p>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.data.technicalExpertName ?
                                                        <div className="row  mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Technical Expert</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.technicalExpertName}</p>
                                                        </div>


                                                    </div>
                                                    :""
                                                    }
                                                    
                                                    {
                                                        this.state.data.auditorOneName ?
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Auditor One</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.auditorOneName}</p>
                                                        </div>
                                                    </div>
                                                    :""
                                                    }
                                                    {
                                                        this.state.data.auditorTwoName ?
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Auditor Two</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.auditorTwoName}</p>
                                                            
                                                            </div>
                                                        </div>
                                                        :""
                                                    }
{
    this.state.data.typeOfCertification === "ISO 27001-2013 ISMS Requirements" ?
    <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-4 labelsize">Reason for the reduction/increase of M/D</label>



                                                    <div style={{ marginLeft: "400px" }}>
                                                        <div className="col-sm-6"><b>Increase1:</b></div>
                                                        <ul>
                                                            {
                                                                this.state.data.increase1 && this.state.data.increase1.length > 0 ?
                                                                    this.state.data.increase1.map((item, index) => {
                                                                        return (
                                                                            <li key={index} className="mt-2">{item}

                                                                            </li>
                                                                        )
                                                                    })
                                                                    :
                                                                    ""
                                                            }
                                                        </ul>

                                                        <div className="col-sm-6"><b>Decrease1:</b></div>
                                                        <ul>
                                                            {
                                                                this.state.data.increase1 && this.state.data.increase1.length > 0 ?
                                                                    this.state.data.decrease1.map((item, index) => {

                                                                        return (
                                                                            <li key={index} className="mt-2" >{item}

                                                                            </li>
                                                                        )
                                                                    })
                                                                    : ""
                                                            }


                                                        </ul>
                                                    </div>
                                                </div>
                                                :
                                                <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Reason for the reduction/increase of M/D</label>
                                                   
                                                   

                                                        <div style={{marginLeft:"400px"}}>
                                                                        <div className="col-sm-6"><b>Increase:</b></div>
                                                                        <ul>
                                                                            {
                                                                                this.state.data.increase && this.state.data.increase.length > 0 ?
                                                                                this.state.data.increase.map((item, index) => {
                                                                                    return (
                                                                                        <li key={index} className="mt-2">{item}

                                                                                        </li>
                                                                                    )
                                                                                })
                                                                                :
                                                                                ""
                                                                            }
                                                                        </ul>
                                                               
                                                                        <div  className="col-sm-6"><b>Decrease:</b></div>
                                                                        <ul>
                                                                            {
                                                                                this.state.data.increase && this.state.data.increase.length > 0 ?
                                                                                this.state.data.decrease.map((item, index) => {

                                                                                    return (
                                                                                        <li key={index} className="mt-2" >{item}

                                                                                        </li>
                                                                                    )
                                                                                })
                                                                                :""
                                                                            }


                                                                        </ul>
                                                                        </div>
                                                    </div>

}
                                                    
                                                
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Application Status</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.statusoOfApplication}</p>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Reason if declined/rejected</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.reasonForDecline === "" ? "Not Applicable" : this.state.data.reasonForDecline}</p>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Review Conducted By (Secretariat / MT) </label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.reviewConductedBy}</p>
                                                        </div>


                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Reviewer Name</label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.reviewerName}</p>
                                                        </div>


                                                    </div>
                                                    
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">External Review Conducted By </label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.externalReviewConductedBy}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Approved by (DT) </label>
                                                        <div className="col-sm-4">
                                                            <p>{this.state.data.approvedBy}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-4 labelsize">Date</label>
                                                        <div className="col-sm-4">
                                                            <p>{moment(this.state.data.appvDate).format('DD-MMM-YYYY')}</p>
                                                        </div>
                                                    </div>
                                               
                                                    <div className="row mt-4">
                                                       

                                                       <div>
                                                               <div className="row mt-4">
                                                                   <hr className="mt-4" />
                                                                   <div className="col-sm-6 text-dark ">
                                                                       <h5>Download Contract Review</h5>
                                                                   </div>
                                                                   <div className="col-sm-4"/>
                                                                   
                                                                   <button className="btn btn-primary btn-sm col-sm-2 mb-2 ml-2" onClick={() => this.generateReviewProcess()}>Download</button>
                                                                   
                                                                   <hr />
                                                               </div>
                                                       </div>
                                                  {
                                                      localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                     ""
                                                     :
                                                   <div style={{ display: this.state.uploadDocumentStatus }}>
                                                       <div className="row mt-4">
                                                           <hr className="mt-4" />
                                                           <div className="col-sm-6 text-dark ">
                                                               <h5>Upload Contract Review</h5>
                                                           </div>
                                                           <hr />
                                                           <div className="row mt-5" >
                                                               <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload Contract Review</label></div>
                                                               <div className="col-sm-6">
                                                               <p style={{color:"red" ,display:this.state.messageforvalidation}}>Please Select Size Which is less than 3 MB</p>
                                                                   {
                                                                       this.state.reportOfcontractreview.contractreviewurl !== "" ?
                                                                           <FileReviewProcess />
                                                                           :
                                                                           <>
                                                                               <input type='file' ref={this.viewprocessUrlInput} onChange={this.handleprocessreview} />
                                                                               <br></br>

                                                                           </>
                                                                   }
                                                               </div>
                                                           </div>
                                                           <div className="row">
                                                               <div className="col-sm-6" />
                                                               <div className="col-sm-4" />
                                                               <button type="button" className="btn btn-sm btn-success col-sm-2 mb-2 mr-2" onClick={() => this.postData()} disabled={this.state.uploadStatus}>Upload</button>
                                                              

                                                           </div>

                                                       </div>
                                                       
                                                   </div>
                                                   }
                                                 

                                                 
                                                   
                                               </div>
                                               <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                    <div className="row mt-5" >
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>Uploaded Contract Review</h5>
                                                        </div>
                                                        <hr />
                                                        <div className="col-sm-4">

                                                            <label className="mt-4 labelsize">
                                                                Uploaded Contract Review
                                                            </label>

                                                        </div>
                                                        <div className="col-sm-6">
                                                            {
                                                                this.state.uploadedProcessUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedProcessUrl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadSignedPdf()}/>
                                                                        <p>{this.state.uploadedFileNameToshow}</p>
                                                                        {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                        ""
                                                                        :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                        }
                                                                    </>
                                                                    :
                                                                    this.state.uploadedProcessUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }}  onClick={()=>this.downloadSignedPdf()}/>
                                                                           
                                                                           { 
                                                                             localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                             ""
                                                                             :
                                                                                <span>
                                                                                    <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                </span>
                                                                            }
                                                                             <p>{this.state.uploadedFileNameToshow}</p>
                                                                            </>

                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                      localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      
                                                      !this.state.uploadedProcessUrl  ?
                                                      <>
                                                     
                                                     
                                                         <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>
                                                             
                                                               </> 
                                                                
                                                                :
                                                                ""
                                                                :
                                                                ""

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
                {
                    localStorage.getItem("userRole") === "Management" || localStorage.getItem("userRole") === "Lead Auditor" || localStorage.getItem("userRole") === "Auditor" || localStorage.getItem("userRole") === "Asst Auditor" || localStorage.getItem("userRole") === "Accounts" ?
                        ""
                        :
                        <div className="card-footer">
                            <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    {
                                    this.state.editStatus ?
                                    ! this.state.uploadedProcessUrl ?
                                        <button className="btn btn-primary float-right ml-5" onClick={() => { this.handleRoute() }}>Edit</button>
                                        : 
                                        <div></div>
                                        :"" 
                                    }
                                </div>

                            </div>
                        </div>
                }

            </div>
        )
    }
}

